<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :title="$i18n.t('dialog.title.sewerDataProfile')"
    agree-text="dialog.exportProfile"
    disagree-text="dialog.close"
    max-height="90vh"
    dialog-width="85vw"
    @agree="exportProfile"
  >
    <template #body>
      <v-col cols="12">
        <v-row no-gutters class="overflow">
          <v-col>
            <img class="mb-3" :src="image" />
          </v-col>
        </v-row>
      </v-col>
    </template>
  </main-large-dialog>
</template>
<script>
import MainLargeDialog from '@/components/MainLargeDialog';
export default {
  name: 'SewerDataProfileDialog',
  components: {
    MainLargeDialog,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    imageName: {
      type: String,
      required: true,
    },
  },
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
  },
  methods: {
    exportProfile() {
      this.$_saveFile(this.image, this.imageName);
    },
  },
};
</script>
